<template>
  <b-modal
    v-model="visible"
    title="Documentación incompleta"
    hide-footer
    no-close-on-backdrop
    header-class="bg-danger text-white"
  >
    <div class="d-flex align-items-start mb-3">
      <i class="ri-lock-line mr-2 text-danger" style="font-size:1.4rem; flex-shrink:0;"></i>
      <p class="mb-0">{{ message }}</p>
    </div>

    <div v-if="missingDocuments && missingDocuments.length" class="mb-3">
      <strong class="text-danger">Documentos faltantes:</strong>
      <ul class="mt-2 mb-0">
        <li v-for="doc in missingDocuments" :key="doc">{{ doc }}</li>
      </ul>
    </div>

    <div class="d-flex justify-content-end">
      <router-link
        v-if="employeeId"
        :to="{ name: 'employee-details', params: { id: String(employeeId) } }"
        class="button button-primary mr-2"
        @click.native="close"
      >
        <i class="ri-folder-open-line mr-1"></i>Ir a Legajo documental
      </router-link>
      <button class="button button-light" @click="close">Cerrar</button>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'DocumentComplianceModal',
  computed: {
    ...mapState('compliance', ['error']),
    visible: {
      get() { return !!this.error },
      set(val) { if (!val) this.clearError() },
    },
    message()          { return this.error ? this.error.message          : '' },
    missingDocuments() { return this.error ? this.error.missingDocuments : [] },
    employeeId()       { return this.error ? this.error.employeeId       : null },
  },
  methods: {
    ...mapMutations('compliance', ['clearError']),
    close() { this.clearError() },
  },
}
</script>
